var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCached(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_210_5558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_210_5558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0504 19.75C9.8876 19.75 8.04693 18.9974 6.52843 17.4923C5.00976 15.9871 4.25043 14.1563 4.25043 12V11.2192L2.40043 13.0693L1.34668 12.0155L5.00043 8.3615L8.65418 12.0155L7.60043 13.0693L5.75043 11.2192V12C5.75043 13.7372 6.36193 15.2132 7.58493 16.428C8.8081 17.6427 10.2966 18.25 12.0504 18.25C12.4646 18.25 12.8783 18.2048 13.2917 18.1145C13.7052 18.024 14.1088 17.8884 14.5024 17.7078L15.6274 18.8328C15.0646 19.1353 14.4835 19.3637 13.8842 19.5182C13.2847 19.6727 12.6734 19.75 12.0504 19.75ZM19.0004 15.6385L15.3467 11.9845L16.4004 10.9307L18.2504 12.7808V12C18.2504 10.2628 17.6389 8.78683 16.4159 7.572C15.1928 6.35733 13.7043 5.75 11.9504 5.75C11.5363 5.75 11.1225 5.79517 10.7092 5.8855C10.2957 5.976 9.8921 6.11158 9.49843 6.29225L8.37343 5.16725C8.93626 4.86475 9.51735 4.63625 10.1167 4.48175C10.7162 4.32725 11.3274 4.25 11.9504 4.25C14.1133 4.25 15.9539 5.00258 17.4724 6.50775C18.9911 8.01292 19.7504 9.84367 19.7504 12V12.7808L21.6004 10.9307L22.6542 11.9845L19.0004 15.6385Z",
    fill: "#C1FEE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCached);
export default __webpack_public_path__ + "static/media/cached.32152042562b3ff3b8409e1f99a790b5.svg";
export { ForwardRef as ReactComponent };